<template>
  <div class="statistic-courier-table">
    <v-data-table
      v-if="tableData.length"
      fixed-header
      :headers="headers"
      :items="tableData"
      :items-per-page="-1"
      class="statistic-datatable orange-header"
      :footer-props="{disableItemsPerPage: true}"
    >
      <template v-slot:item.user="{ item }">
        <div class="statistic-datatable__user-column stat-user-column flex align-center">
          <color-letters-avatar
            :user="item.user"
            :border="false"
            :color="getUserColor(item.user.id)"
            class="stat-user-column__avatar"
          />
          <span class="stat-user-column__name">{{ item.user.name }}</span>
        </div>
      </template>
    </v-data-table>
    <div v-else class="no-data-label">
      Нет записей за выбранный период
    </div>
  </div>
</template>
<script>
  // import Avatar from '@/components/administrator/work-shift/staff/Avatar'
  import ColorLettersAvatar from '@/components/ui/user/ColorLettersAvatar'

  export default {
    name: 'CourierStatTable',
    components: { ColorLettersAvatar },
    data () {
      return {
        headers: [
          { text: 'Сотрудник', value: 'user', align: 'left' },
          { text: 'Среднее время доставки, мин', value: 'averageDeliveryTime', align: 'center' },
          { text: 'Доставлено заказов', value: 'orderDelivered', align: 'center' },
          { text: 'Кол-во опозданий', value: 'delays', align: 'center' },
          { text: 'Отработано часов', value: 'worked', align: 'center' },
          { text: 'СВД зеленая зона', value: 'averageDeliveryTimeGreen', align: 'center' },
          { text: 'СВД желтая зона', value: 'averageDeliveryTimeYellow', align: 'center' },
          { text: 'СВД красная зона', value: 'averageDeliveryTimeRed', align: 'center' },
        ],
      }
    },
    props: {
      tableData: {
        type: Array,
        default: () => [],
      },
      userColors: {
        type: Object,
        default: () => ({}),
      },
    },
    methods: {
      getUserColor (userId) {
        return this.userColors[userId] ?? '#CCC'
      },
    },

  }
</script>

<style lang="less" scoped>
@import "src/assets/styles/statistic.less";
.statistic-courier-table {
  //margin-bottom: 50px;
}

</style>
